import { render, staticRenderFns } from "./GeographyTab.vue?vue&type=template&id=87e293e0&scoped=true"
import script from "./GeographyTab.vue?vue&type=script&lang=ts"
export * from "./GeographyTab.vue?vue&type=script&lang=ts"
import style0 from "./GeographyTab.vue?vue&type=style&index=0&id=87e293e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e293e0",
  null
  
)

export default component.exports